import { Glitch } from '@components/helpers/Glitch';

interface ButtonProps {
  type?: 'submit' | 'button';
  children?: React.ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  glitch?: boolean;
}

export function Button(props: ButtonProps) {
  const InnerContent = () => {
    if (!props.isLoading) return props.children;

    return <span className="loader" />;
  };

  return (
    <button
      className={`${props.className} btn text-sm`}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
    >
      <Glitch disabled={!props.glitch}>
        <InnerContent />
      </Glitch>
    </button>
  );
}